import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import Capabilities from "./pages/Capabilities";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Quality from "./pages/Quality";
import Facilities from "./pages/Facilities";
import Contact from "./pages/Contact";

import Careers, { CareerDetail } from "./pages/Careers";
import Certifications from "./pages/Certifications";
import PageView from "./pages/PageView";
import AdminApp from "./admin/AdminApp";
import StaffApp from "./staff/StaffApp";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicSite = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/services" element={<Services />} />
        <Route path="/capabilities" element={<Capabilities />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/quality" element={<Quality />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:jobId" element={<CareerDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/p/:slug" element={<PageView />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/app/*" element={<StaffApp />} />
        <Route path="/*" element={<PublicSite />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
